import { useTranslation } from 'next-i18next';

import { zusToast } from '@zep/toast';

import { type QuizBankBuildPlace } from '../tracking/events.quiz-bank';

import { useShowQuizBankModal } from './useShowQuizBankModal';

/**
 * 빌드 편집 화면의 문제 은행 진입점 상태 — 이 퀴즈 과목이 build-info 의 문제 은행 노출 과목이 아니면
 * `unsupported`. 노출 과목이면 상한에 닿았는지(`isFull`)와 열기를 준다.
 * 가득 차도 진입점은 그대로 눌린다 — AI 생성 진입처럼 누르면 상한 안내를 띄운다.
 */
export type QuizBankEntry =
  | { status: 'unsupported' }
  | {
      status: 'available';
      isFull: boolean;
      remainingSlots: number;
      open: (place: QuizBankBuildPlace) => void;
    };

export const useQuizBankEntry = (): QuizBankEntry => {
  const { t } = useTranslation(['build']);
  const { isSupported, remainingSlots, open } = useShowQuizBankModal();

  if (!isSupported) return { status: 'unsupported' };
  const isFull = remainingSlots === 0;
  return {
    status: 'available',
    isFull,
    remainingSlots,
    open: place => {
      if (isFull) {
        zusToast.error(t('build:build.alert.quizLimit'));
        return;
      }
      void open(place);
    },
  };
};
